import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResultPromise from 'ContentEditorUI/earlyRequester/getEarlyRequesterResultPromise';
const KNOWLEDGE_CATEGORY = 'knowledge-content/v2/category';
export const getKnowledgeBase = knowledgeBaseId => getEarlyRequesterResultPromise('knowledgeBase') || http.get(`knowledge-content/v2/knowledge-base/${knowledgeBaseId}`);
export const getCategories = query => http.get(`${KNOWLEDGE_CATEGORY}/list`, {
  query
});
export const createCategory = (knowledgeBaseId, name, description, parentCategoryId, translations = {}) => http.post(`${KNOWLEDGE_CATEGORY}/translation`, {
  data: {
    knowledgeBaseId,
    name,
    description,
    parentCategoryId,
    translations
  }
});

/**
 * Updates a knowledge base category.
 * @param existingCategory - The complete current category object
 * @param updatedCategory - Partial category object containing only the properties to update
 * @returns Promise resolving to the updated Category
 * @remarks The entire category object must be sent to this endpoint. Any missing properties
 * will be reset to their default values, which is why we spread both objects.
 */
export const updateCategory = (existingCategory, updatedCategory) => http.put(`${KNOWLEDGE_CATEGORY}/translation/${existingCategory.id}`, {
  data: Object.assign({}, existingCategory, updatedCategory)
});